import { Switch } from 'react-router-dom'
import { pathify } from '@cims-online/shared'
import { ProtectedRoute } from '../../../../../components/ProtectedRoute'
import Fields from './Fields'
import Notifications from './Notifications'
import Permissions from './Permissions'
import Records from './Records'

type WorkflowProps = {
  label: string
}

const Workflow: React.VFC<WorkflowProps> = () => (
  <Switch>
    <ProtectedRoute
      path={pathify(':projectId', 'workflows', ':workflowId', 'records')}
    >
      <Records />
    </ProtectedRoute>
    {/* This page will be implemented post MVP when we add actual edit controls. */}
    {/* <ProtectedRoute
      path={pathify(':projectId', 'workflows', ':workflowId', 'settings')}
    >
      <div>The {label} settings page</div>
    </ProtectedRoute> */}
    {/* This page will be implemented post MVP when we add actual edit controls. */}
    {/* <ProtectedRoute
      path={pathify(':projectId', 'workflows', ':workflowId', 'statuses')}
    >
      <div>The {label} statuses page</div>
    </ProtectedRoute> */}
    <ProtectedRoute
      path={pathify(':projectId', 'workflows', ':workflowId', 'fields')}
    >
      <Fields />
    </ProtectedRoute>
    {/* This page will be implemented post MVP when we add actual edit controls. */}
    {/* <ProtectedRoute
      path={pathify(':projectId', 'workflows', ':workflowId', 'plugins')}
    >
      <div>The {label} plugins page</div>
    </ProtectedRoute> */}
    <ProtectedRoute
      path={pathify(':projectId', 'workflows', ':workflowId', 'notifications')}
    >
      <Notifications />
    </ProtectedRoute>
    <ProtectedRoute
      path={pathify(':projectId', 'workflows', ':workflowId', 'permissions')}
    >
      <Permissions />
    </ProtectedRoute>
  </Switch>
)

export default Workflow
